import {
  ContractLinkCreateAction,
  contractLinkCreateLoadPdfRequest,
  contractLinkCreateLoadPdfSuccess,
} from '@app/features/contractLink/contractLinkCreate';
import {
  TEMPLATE_CLEAR_ALL_STATE,
  TEMPLATE_CREATE__PDF_LOAD_SUCCESS,
  TEMPLATE_EDIT__PDF_LOAD_REQUEST,
  TEMPLATE_EDIT__PDF_LOAD_SUCCESS,
  TEMPLATE_FILE_CHANGE__PDF_INITIALIZE,
  TEMPLATE_FILE_CHANGE__PDF_LOAD_SUCCESS,
} from '@app/store/actionTypes';
import { scheduledDocumentPreviewDataFetched, TemplateAction } from '@app/store/template/actions';

type TemplatePdfArrayBuffer = ArrayBuffer | null;

const initialState: TemplatePdfArrayBuffer = null;

export default function reducer(
  state: TemplatePdfArrayBuffer = initialState,
  action: TemplateAction | ContractLinkCreateAction
) {
  switch (action.type) {
    case contractLinkCreateLoadPdfRequest.type:
    case TEMPLATE_CLEAR_ALL_STATE:
    case TEMPLATE_EDIT__PDF_LOAD_REQUEST:
    case TEMPLATE_FILE_CHANGE__PDF_INITIALIZE:
      return initialState;
    case contractLinkCreateLoadPdfSuccess.type:
    case TEMPLATE_CREATE__PDF_LOAD_SUCCESS:
    case TEMPLATE_EDIT__PDF_LOAD_SUCCESS:
    case TEMPLATE_FILE_CHANGE__PDF_LOAD_SUCCESS:
    case scheduledDocumentPreviewDataFetched.type:
      return action.payload.pdfArrayBuffer;
    default:
      return state;
  }
}
